/* Opt-in cookie-settings control (account / Settings reuse).
 * Retail V1: not mounted as persistent CustomerAppShell chrome — Settings
 * opens the banner via `openCookieSettings` / `openBanner({ force: true })`.
 * Component kept for unit tests and any account panel that still embeds it.
 */

import { useTranslation } from 'react-i18next';

import { isAcceptAllDecision } from './consentPolicy.js';
import { useCookieConsent } from './CookieConsentProvider.js';

/** Opens the cookie banner for preference editing (Settings / account). */
export function openCookieSettings(
  openBanner: (opts?: { preselectFunctional?: boolean; force?: boolean }) => void,
): void {
  openBanner({ force: true });
}

export function CookieConsentFooter(): JSX.Element | null {
  const { t } = useTranslation('customer');
  const consent = useCookieConsent();
  if (consent.decision === null || consent.isBannerOpen) {
    return null;
  }
  if (
    isAcceptAllDecision(consent.decision, {
      loyaltyProfilingAvailable: consent.loyaltyProfilingAvailable,
    })
  ) {
    return null;
  }
  return (
    <footer
      className="mt-auto flex justify-center py-3"
      aria-label={t('consent.footerLabel')}
      data-testid="cookie-consent-footer"
    >
      <div className="rounded-md bg-[var(--color-surface)]/95 px-3 py-1 shadow-sm backdrop-blur">
        <button
          type="button"
          className="text-xs text-[var(--color-on-surface-muted)] underline"
          onClick={() => {
            openCookieSettings(consent.openBanner);
          }}
        >
          {t('consent.settingsLink')}
        </button>
      </div>
    </footer>
  );
}
